<!-- grok.component.html -->
<div class="grok-dialog">
  <!-- Close -->
  <button class="close-btn" (click)="close()" aria-label="Close dialog">×</button>

  <div class="header">
    <img src="assets/logos/xai.svg" alt="Grok 4 Logo" class="logo" />
    <h2>Grok 4</h2>
    <div class="sub">
      xAI’s high-performance reasoning model for fast, direct answers, strong analysis, and practical execution.
    </div>
  </div>

  <div class="body">
    <p>
      <strong>Grok 4</strong> is built to feel sharp and efficient: it prioritizes
      <strong>clear reasoning</strong>, <strong>actionable output</strong>, and <strong>high signal</strong>
      responses over filler.
      It’s especially useful for users who want the model to “get to the point” while still showing
      the logic behind recommendations—perfect for <strong>math</strong>, <strong>debugging</strong>,
      <strong>planning</strong>, and <strong>decision support</strong>.
      <br /><br />
      In user-facing apps, Grok 4 shines when you need quick iterations: ask → refine → execute.
      It’s a strong choice for interactive workflows, tool-driven assistants, and structured tasks that
      benefit from concise steps and consistent formatting.
    </p>

    <ul>
      <li>🧠 <strong>Analytical reasoning:</strong> Strong step-by-step logic for math, troubleshooting, and “why” explanations with clear takeaways.</li>
      <li>🧑‍💻 <strong>Developer-friendly:</strong> Great for code drafting, refactoring, debugging loops, and implementation checklists.</li>
      <li>📌 <strong>Concise, executive style:</strong> Produces tight summaries, decisions, and action items for busy users.</li>
      <li>🧾 <strong>Structured output:</strong> Reliable formatting (bullets, steps, tables, JSON-like schemas) when the UI needs predictable structure.</li>
      <li>🛡️ <strong>Safety-aware responses:</strong> Clear boundaries and refusals when needed, with safer alternatives when possible.</li>
    </ul>

    <div class="optimal">
      <h3>Reasoning controls</h3>
      <ul>
        <li><strong>Auto:</strong> adapts effort to the task — best default for mixed workloads.</li>
        <li><strong>Instant:</strong> minimal deliberation for speed — best for simple Q&amp;A and quick edits.</li>
        <li><strong>Thinking:</strong> more analysis for planning, multi-step problems, and complex explanations.</li>
        <li><strong>Pro:</strong> maximum depth for complex reasoning, long plans, and higher-stakes decisions.</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>When is Grok 4 optimal?</h3>
      <ul>
        <li>Complex reasoning, math, and “show-your-work” explanations users can follow</li>
        <li>Coding help: refactors, debugging, implementation steps, and quick architecture notes</li>
        <li>Turning long input into sharp briefings, action items, or decision-ready summaries</li>
        <li>Fast iteration workflows (prompt refinement, ops checklists, analysis loops)</li>
        <li>Assistive Q&amp;A that needs clear boundaries and consistent, safe output</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>Recommended user prompt pattern</h3>
      <ul>
        <li>Ask for a <strong>short answer</strong> first (one paragraph or bullets)</li>
        <li>Request a <strong>checklist or steps</strong> next (so users can execute immediately)</li>
      </ul>
    </div>
  </div>
</div>
